import {
    type GetAllSubEventsForAdminResponseType,
    type GetAllSubEventsForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getAllSubEventsForAdmin = async (params: GetAllSubEventsForAdminRequestType): Promise<GetAllSubEventsForAdminResponseType> => {
    return await request<GetAllSubEventsForAdminResponseType>(`/events/getAllSubEventsForAdmin?eventID=${params.eventID}`, {
        method: "GET"
    });
};

export default getAllSubEventsForAdmin;
